export const ACTION_ADD_AFFILIATE_PROGRAMS = 'ACTION_ADD_AFFILIATE_PROGRAMS';

export const ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST = 'ACTION_LOAD_AFFILIATE_PROGRAMS__REQUEST';
export const ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS = 'ACTION_LOAD_AFFILIATE_PROGRAMS__SUCCESS';
export const ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL = 'ACTION_LOAD_AFFILIATE_PROGRAMS__FAIL';
